module.exports = __webpack_public_path__ + "img/lw-big-1.8d9a2219.jpg";